/*
 * @Description: 提供给拦截器使用
 * @Date: 2022-01-15 17:49:40
 */

const request = {
  namespaced: true,
  state: {
    global: {} // 全局参数
  }
};

export default request;
